define('TescoMobile_CareHub/js/action/end-session',['mage/url'], function (urlBuilder) {
  'use strict';

  return function () {
    window.open(urlBuilder.build('carehub/relay/end'), "_self");
  };
});

